function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import React from "react";
var _ref2 = /*#__PURE__*/React.createElement("path", {
  d: "M15.3546 2.6437C13.7223 1.0125 11.4822 0 8.9944 0 4.0188 0 0 4.0275 0 9s4.0188 9 8.9944 9c4.1988 0 7.6998-2.8687 8.7017-6.75h-2.3415c-.9231 2.6213-3.4221 4.5-6.3602 4.5C5.2683 15.75 2.24 12.7238 2.24 9c0-3.7237 3.0282-6.75 6.7543-6.75 1.8686 0 3.5347.7763 4.7504 2.0025L10.1201 7.875H18V0l-2.6454 2.6437z",
  fill: "currentColor"
});
var SvgRefresh = function SvgRefresh(_ref) {
  var svgRef = _ref.svgRef,
    props = _objectWithoutProperties(_ref, ["svgRef"]);
  return React.createElement("svg", _extends({
    width: 18,
    height: 18,
    viewBox: "0 0 18 18",
    fill: "currentColor",
    ref: svgRef
  }, props), _ref2);
};
var ForwardRef = React.forwardRef(function (props, ref) {
  return React.createElement(SvgRefresh, _extends({
    svgRef: ref
  }, props));
});
export default __webpack_public_path__ + "static/media/refresh.095162d7.svg";
export { ForwardRef as ReactComponent };